import { Dialog, DialogTitle, DialogContent, Alert, Box, FormControl, TextField, InputLabel, Select, SelectChangeEvent, MenuItem, DialogActions, Button, Typography, RadioGroup, FormControlLabel, Radio, FormLabel, Autocomplete, ListItemText, createFilterOptions, Grid, Table, TableCell, TableHead, TableRow, TableBody, Switch } from '@mui/material';
import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { NombrePilaVariacion } from '../NombresPilaVariaciones/NombrePilaVariacion';
import { NombrePila } from '../NombresPila/NombrePila';

export interface IRepairNombreProps {
    id: number;
    variacion: string;
    open: boolean;
    onCancel?: any;
    onSave?: any;
}

export interface IRepairNombreState {
    normalizacionItem: any;
    open: boolean;
    data: any;
}

export default class RepairNombre extends React.Component<IRepairNombreProps, IRepairNombreState> {
    _id: number = -1;

    public constructor(props: IRepairNombreProps) {
        super(props);

        this.state = {
            open: false,
            normalizacionItem: null,
            data: {
                nombre: [],
                apellidos: []
            }
        };
    }

    componentWillReceiveProps(nextProps: Readonly<IRepairNombreProps>, nextContext: any): void {
        this._id = nextProps.id;
        this.GetData();
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth maxWidth='md' >
                <DialogTitle>
                    {
                        `Reparar nombre`
                    }
                </DialogTitle>
                <DialogContent>
                    <Typography variant='body2' marginBottom={'20px'}>
                        {
                            `Establezca las partes del nombre "${this.props.variacion.toUpperCase()}"`
                        }
                    </Typography>
                    {
                        (this.state.data.nombre.length > 0 || this.state.data.apellidos.length > 0) && (
                            <Typography variant='body2' marginBottom={'20px'}>
                                {
                                    `Nuevo nombre ${this.state.data.nombre.join(' ').toUpperCase()} ${this.state.data.apellidos.join(' ').toUpperCase()}`
                                }
                            </Typography>
                        )
                    }
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Parte</TableCell>
                                <TableCell>Nombre/Apellido</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            this.props.variacion.split(' ').map((nombre: string, index: number) => {
                                return(
                                    <TableRow key={index}>
                                         <TableCell component='th' scope="row" sx={{width: '70%'}}>
                                            {
                                                nombre
                                            }
                                         </TableCell>
                                         <TableCell sx={{width: '30%'}}>
                                            <FormControl variant="standard" fullWidth>
                                                <InputLabel id="selectNombreApellidoInput">Nombre/Apellido</InputLabel>
                                                <Select
                                                    labelId="selectNombreApellidoInput"
                                                    id="selectNombreApellido"
                                                    label="Nombre/Apellido"
                                                    onChange={(event: SelectChangeEvent) => {
                                                        this.SetNombre(nombre, event.target.value == 'Nombre');
                                                    }}
                                                >
                                                    <MenuItem value={'Nombre'}>Nombre</MenuItem>
                                                    <MenuItem value={'Apellido'}>Apellido</MenuItem>
                                                </Select>
                                            </FormControl>
                                         </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Save.bind(this)}>Ok</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private SetNombre(parte: string, esNombre: boolean) {
        const data = this.state.data;
        const nombres = data.nombre;
        const apellidos = data.apellidos;
        let indexOf = -1;

        indexOf = nombres.indexOf(parte);
        if (indexOf > -1) {
            nombres.splice(indexOf, 1);
        }

        indexOf = apellidos.indexOf(parte);
        if (indexOf > -1) {
            apellidos.splice(indexOf, 1);
        }

        if(esNombre) {
            data.nombre.push(parte);
        }
        else {
            data.apellidos.push(parte);
        }

        this.setState(
            {
                data: data
            }
        );
    }

    private GetData() {
        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    normalizacionItem: response[0]
                }
            );
        });
    }

    private Close() {
        if(this.props.onCancel != null) {
            this.props.onCancel();
        }
    }

    private Save() {
        const normalizacionItem = JSON.parse(JSON.stringify(this.state.normalizacionItem));
        normalizacionItem.nombre = this.state.data.nombre.join(' ');
        normalizacionItem.apellidos = this.state.data.apellidos.join(' ');

        if(normalizacionItem.fechaNacimiento.indexOf == undefined) {
            normalizacionItem.fechaNacimiento = '';
        }

        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}/update/nombre`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(normalizacionItem),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            if(this.props.onSave != null) {
                this.props.onSave(response);
                this.setState({
                    data: {
                        nombre: [],
                        apellidos: []
                    }                   
                })
            }
        })
    }
}